import React from "react";
import DataTable from "../../DataTable/index";
import IconButton from "@mui/material/IconButton";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

const label = {inputProps: {"aria-label": "Switch demo"}};

export default function MyComponent(props) {
    const userRole = useSelector((state) => state.userDetailsReducer?.role);
    const columns =
        userRole === "admin" || userRole === "super"
            ? [
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Name
                        </Typography>
                    ),
                    selector: (row) => row.name,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.name}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Description
                        </Typography>
                    ),
                    selector: (row) => row.desription,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.description}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Actions
                        </Typography>
                    ),
                    sortable: true,
                    cell: (row) => {
                        return (
                            <>
                                <IconButton
                                    style={{borderRadius: 5}}
                                    disabled={userRole === "player" ? true : false}
                                    onClick={() => {
                                        props.setselectedrows(row);
                                        props.seteditVisible(!props.editVisible);
                                        props.setName(row.name);
                                        props.setDescription(row.description);
                                        props.setPlayerIds([...row.players.map(player => player._id)]);
                                        props.setLogo(row.logo);
                                    }}
                                    color="primary"
                                    size="medium"
                                >
                                    <EditRoundedIcon fontSize="medium"/>
                                </IconButton>
                                <IconButton
                                    style={{borderRadius: 5}}
                                    disabled={userRole === "player" ? true : false}
                                    onClick={() => {
                                        props.onDeletePress();
                                        props.setselectedrows(row);
                                    }}
                                    color="primary"
                                    size="medium"
                                >
                                    <DeleteRoundedIcon fontSize="medium"/>
                                </IconButton>
                            </>
                        );
                    },
                },
            ]
            : [
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Name
                        </Typography>
                    ),
                    selector: (row) => row.name,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.name}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Chapter
                        </Typography>
                    ),
                    selector: (row) => row.chapter,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.chapter}
                            </p>
                        );
                    },
                },
            ];

    const conditionalRowStyles = {
        headRow: {
            style: {
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "rgba(0,0,0,0.6)",
                borderRadius: "5px",
            },
        },
        cells: {
            style: {
                "&:hover": {
                    cursor: "pointer !important",
                },
            },
        },
    };

    return (
        <DataTable
            columns={columns}
            data={props?.data}
            selectableRows={false}
            persistTableHead
            pagination={false}
            progressPending={props?.progressPending}
            progressComponent={props?.progressComponent}
            customStyles={conditionalRowStyles}
            direction="vertical"
            striped={true}
            onChangeRowsPerPage={props?.onChangeRowsPerPage}
            clearRow={props?.clearRow}
            onSelectedRowsChange={props?.onSelectedRowsChange}
            onRowClicked={props?.onRowClicked}

        />
    );
}
